module.exports = __webpack_public_path__ + "static/media/icn-f.c903f8fe.svg";